import { deepClone } from "src/helpers/deepClone"
import xrmApi, { xrmApiLite } from "src/services/xrmApi"
import { Cart, CartProduct } from "src/states/shop/carts"
import { xRMApiCart } from "src/types/xRM"

export const postCart = async (data: xRMApiCart) => {
  const requestData = deepClone<xRMApiCart>(data)
  requestData.cartId = data.id
  requestData.id = undefined

  await xrmApiLite.post("/cart", requestData)
}

export const retrieveCartFromDb = async (
  cartId: string,
): Promise<Cart | undefined> => {
  return xrmApi.get(`/cart/${cartId}`).then((res) => {
    const products: CartProduct[] = res.data?.products
      ? JSON.parse(res.data.products)
      : []

    return {
      id: res.data.cartId,
      orderId: res.data.orderId,
      products: products,
      revisionNo: res.data.revisionNo,
    } as Cart
  })
}
